// 游戏基础配置参数
export const gameConfig = {
    // 游戏最大步数
    maxSteps: 50,

    // 相机控制配置
    camera: {
        // 视角参数
        fov: 45,
        near: 0.1,
        far: 1000,
        // 控制参数
        controls: {
            minDistance: 10,
            maxDistance: 50,
            zoomSpeed: 1.0,
            rotateSpeed: 0.8,
            enableZoom: true,
            enableRotate: true,
            enablePan: false,
            // 移动设备初始距离
            mobileDistance: 60,
            // PC设备初始距离
            desktopDistance: 40
        }
    },

    // 牌桌相关配置
    table: {
        // 地毯高度（相对于地面）
        carpetHeight: -0.5,
        // 牌桌表面高度（相对于地面）
        surfaceHeight: 1,
        // 牌桌边缘高度（相对于地面）
        edgeHeight: 1.2,
        // 牌桌底座高度（相对于地面）
        baseHeight: 0.5,
        // 牌桌响应式布局配置
        responsive: {
            // 基准屏幕宽度（动态获取当前设备宽度）
            baseScreenWidth: window.innerWidth,
            // 最小缩放比例
            minScale: 0.6,
            // 最大缩放比例
            maxScale: 1.2,
            // 移动设备下的额外缩放比例
            mobileScale: 0.8
        }
    },
    
    // 棋盘大小选项
    boardSizes: {
        small: 4,  // 4x4
        medium: 5, // 5x5
        large: 6  // 6x6
    },

    // 骰子相关配置
    dice: {
        // 骰子间距
        spacing: 2.5,
        // 骰子缩放比例
        scale: 1,
        // 骰子初始下落高度
        initialDropHeight: 25,
        // 骰子最终停留高度
        finalHeight: 3.5,
        // 骰子被选中时的高度
        selectedHeight: 4,
        // 骰子动画持续时间（毫秒）
        animationDuration: 1000,
        // 是否启用自动合并检查
        enableAutoMergeCheck: true,
        // 模型配置
        models: {
            // 普通骰子模型路径
            dice: 'models/dice-number-v5.glb',
            // 炸弹模型路径
            bomb: 'models/grenade.glb',
            // 传送骰子模型路径
            teleport: 'models/dice-number-v5.glb'
        },
        // 炸弹骰子相关配置
        bomb: {
            // 是否启用炸弹功能
            enabled: true,
            // 生成概率（0-1之间）
            probability: 0.01,
            // 爆炸范围（格数）
            range: 1,
            // 爆炸动画持续时间（毫秒）
            explosionDuration: 800,
            // 手榴弹专用缩放比例
            scale: 0.015,
            // 手榴弹专用高度（相对于地面）
            height: 2
        },
        // 传送骰子相关配置
        teleport: {
            // 是否启用传送功能
            enabled: true,
            // 生成概率（0-1之间，保持较低以维持游戏平衡）
            probability: 0.05,
            // 是否允许拖拽交换
            enableDragSwap: true,
            // 传送动画持续时间（毫秒）
            teleportDuration: 1000,
            // 传送特效颜色
            effectColor: 0x00ffff,
            // 传送轨迹高度
            pathHeight: 5,
            // 特效缩放
            effectScale: 1.2,
            // 长按触发时间（毫秒）
            longPressDuration: 500
        }
    },

    // 游戏UI配置
    ui: {
        // 是否启用开始倒计时
        enableCountdown: false,
        // 倒计时时间（秒）
        countdownDuration: 3,
        // 是否启用调试面板
        enableDebugPanel: true,
        // 字体配置
        fonts: {
            // 思源黑体字体文件路径
            sourceSans: 'fonts/SourceHanSansCN-Regular.json',
            // 字体大小配置
            size: 2.0,
            // 字体厚度
            height: 0.4,
            // 字体曲线细分
            curveSegments: 16,
            // 字体斜角配置
            bevel: {
                enabled: true,
                thickness: 0.05,
                size: 0.03,
                offset: 0,
                segments: 8
            }
        },
        // 方向指示器配置
        indicators: {
            // 指示器高度
            height: 4,
            // 指示器光源强度
            intensity: 1.5,
            // 指示器距离中心点的距离
            distance: 12,
            // 指示器颜色配置
            colors: {
                front: 0xff0000,  // 前方红色
                back: 0x00ff00,   // 后方绿色
                left: 0x0000ff,   // 左侧蓝色
                right: 0xffff00   // 右侧黄色
            }
        }
    }
};
